import type { HotspotDirection } from "../manifest/schema.js";
import { svgIcon } from "./dom.js";

/**
 * Static path data (24x24, stroked) for each arrow direction. up/down/left/right are one arrow rotated with CSS
 * (`.hotspot--dir-*`); `forward` (into the scene) and `back` (out of the scene, towards the camera) are double
 * chevrons so they read differently from plain up/down.
 */
const ARROW_UP = ["M12 20V5", "M6 11l6-6 6 6"] as const;
const PATHS: Record<HotspotDirection, readonly string[]> = {
  up: ARROW_UP,
  down: ARROW_UP,
  left: ARROW_UP,
  right: ARROW_UP,
  forward: ["M6 12l6-6 6 6", "M6 19l6-6 6 6"],
  back: ["M6 5l6 6 6-6", "M6 12l6 6 6-6"]
};

/** The arrow icon shown in place of a navigate hotspot's text label. */
export function arrowIcon(direction: HotspotDirection): SVGSVGElement {
  return svgIcon(PATHS[direction], { class: `arrow-icon arrow-icon--${direction}` });
}
